/*
 * File: NewClientType.tsx
 * Project: a-a
 * File Created: Thursday, 18th September 2025 4:42:16 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 20th March 2026 4:42:05 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import CustomModal from '../../../../../components/shared/CustomModal/CustomModal';
import CustomCard from '../../../../../components/shared/CustomCard/CustomCard';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import zeplinColor from '../../../../../theme/Color';
import CustomButton from '../../../../../components/shared/CustomButton/CustomButton';
import style from './NewClientType.module.css';
import CustomPlatformSelection from '../../../../../components/shared/CustomPlatformSelection/CustomPlatformSelection';

const NewClientType = ({
  modalOpen,
  handleModalClose,
  handleContinueAdd,
  setTypeSelected,
  typeSelected,
  setPlatformSelected,
  platformSelected,
  setAnchorEl,
  sf_token,
}: {
  modalOpen: boolean;
  handleModalClose: () => void;
  handleContinueAdd: () => void;
  setTypeSelected: React.Dispatch<React.SetStateAction<string>>;
  typeSelected: string;
  setPlatformSelected: React.Dispatch<React.SetStateAction<string>>;
  platformSelected: string;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  sf_token: string;
}) => {
  const handleType = (item: any) => {
    setTypeSelected(item.target.value);
  };
  const clientType = ['Talent', 'Athlete', 'Business Development'];
  return (
    <CustomModal handleClose={() => {}} open={modalOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '16px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,

            width: { xs: '300px', xl: '339px' },
            // height: '183px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '14px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Create Client
                </Typography>
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                  Select where you want to create this client and choose its type.
                </Typography>
              </Box>
              <img
                src={'/assets/cross.svg'}
                alt='logo'
                className={style.icon}
                onClick={handleModalClose}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <CustomPlatformSelection
              sf_token={sf_token}
              setPlatformSelected={setPlatformSelected}
              platformSelected={platformSelected}
              setAnchorEl={setAnchorEl}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography variant='responsiveBody2'>Select Type</Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <RadioGroup
                  aria-labelledby='demo-controlled-radio-buttons-group'
                  name='controlled-radio-buttons-group'
                  value={typeSelected}
                  onChange={handleType}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                    padding: '0px',
                  }}
                >
                  {clientType.map((name) => (
                    <FormControlLabel
                      value={name}
                      control={
                        <Radio
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                      }
                      label={name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '& .MuiFormControlLabel-label': {
                          fontSize: { xs: '14px', xl: '16px' }, // Apply responsive font size to the label
                        },
                        '& .MuiButtonBase-root': {
                          fontSize: { xs: '14px', xl: '16px' },
                          color: zeplinColor.BasicBlack,
                          // border: `1px solid ${zeplinColor.BasicBlack}`,
                        },
                        padding: '0px',
                      }}
                    />
                  ))}
                </RadioGroup>
              </Box>
            </Box>
            <CustomButton
              disabled={clientType[0] ? false : true}
              onClick={handleContinueAdd}
              variant='contained'
              // buttonVariant={'responsiveButtonMedium'}
              color={'primary'}
              style={{
                width: '100%',
                borderRadius: '14px',
                height: 48,
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1, fontSize: { xs: '14px', xl: '16px' } }}
              text={'Continue'}
              // tabindex={4}
            />
          </Box>
        </CustomCard>
        {/* {loading ? <CustomLoader /> : ''} */}
      </Box>
    </CustomModal>
  );
};

export default NewClientType;
